import { FetchData } from "services/api";

/**
 * Connexion initiale (cookie token posé côté serveur / client selon réponse).
 */
export function loginWithCredentials({ username, password }) {
  return FetchData("/api/login", {
    method: "POST",
    body: JSON.stringify({ username, password }),
  });
}

/** Profil utilisateur (cookie token requis — même chaîne que l’ancien `UserContext`). */
export function fetchUserDataRequest() {
  return FetchData("/api/user/user-data", { method: "GET" });
}
